// página de producto
import { useEffect, useState, useRef } from 'react';

//Tag manager
import TagManager from 'react-gtm-module';

//Redux
import { useDispatch, useSelector } from 'react-redux';

//Router dom
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';

//CSS
import './ProductSample.css';

//Swal
import { basicMsg } from '../../../actions/swal_msg';

import {
    saveItemToCart, shopProductViewed
} from '../../../actions/shop';
import { reviewSummaryUpdated } from '../../../actions/review';
import { getTitle } from '../../../helpers/admin/productHelper';
import { formatMainImage } from '../../../helpers/shop/shopHelper';

// componentes
import ProductsFBT from './ProductsFBT';
import AddToCartDialog from './AddToCartDialog';
import PostalCodeModal from './PostalCodeModal';
import ProductContainer from './ProductContainer';
import ProductReviewsSection from './Review/ProductReviewsSection';
import RecentlyViewed from '../RecentlyViewed/RecentlyViewed';

//MUI
import {
    Typography, Breadcrumbs, Backdrop, CircularProgress,
    Grid, Container, Box, useMediaQuery
} from '@mui/material';

//Constants
import { regex_num } from '../../../constants/regex';
import { prodInit, varInit } from '../../../constants/shop/shop_constants';
import { GOOGLE_DRIVE_CDN, PRODUCT_NO_IMG } from '../../../constants/constants';

const tagManagerArgs = {
    gtmId: 'GTM-KQMW2JG'
};
TagManager.initialize(tagManagerArgs);

const ProductSample = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const matches = useMediaQuery('(max-width: 950px)');

    // ruta anterior
    const { state } = useLocation();
    // URL producto
    const { _product, _barcode } = useParams();

    // productos de tienda y datos de navegación
    const {
        categories, brands, products
    } = useSelector(state => state.shop);

    // usuario iniciado
    const { loggedUser } = useSelector(state => state.user);
    const { _id: account_id } = loggedUser;
    // bandera [carga de productos]
    const { loading: { shop_products } } = useSelector(state => state.ui);
    
    // producto y variantes
    const [product, setProduct] = useState(prodInit);
    const { _id: prod_id, info, images, brand } = product;

    // variante activa
    const [variant, setVariant] = useState(varInit);
    const { _id: prod_var_id, stock } = variant;

    // imágenes de variante activa
    const [currentImages, setCurrentImages] = useState([]);

    // cantidad
    const [qty, setQty] = useState(1);
    // URL ruta anterior
    const [previousURL, setPreviousURL] = useState('');

    // productos comprados juntos frecuentemente
    const [fbtItems, setFBTItems] = useState([]);

    // categoría/marca seleccionada (ruta anterior)
    const [breadcrumbData, setBreadcrumbData] = useState({
        bread_url: '', full_url: ''
    });
    const { bread_url, full_url } = breadcrumbData;

    const [fullTitle, setFullTitle] = useState('');
    
    useEffect(() => {
        // obtenemos categoría mediante la ruta previa
        /* state = { previousPath:
            "/tienda/category"
            "/tienda/brand"
        } */
        if (state)
            setPreviousURL(state.previousPath.split('/').pop());
    }, []);

    useEffect(() => {
        if (previousURL) {
            const CategoryFound = categories.find(e => e.url === previousURL);
            if (CategoryFound)
                setBreadcrumbData(e => ({
                    ...e, bread_url: CategoryFound.category,
                    full_url: `/categoria/${CategoryFound.url}`
                }));
            else {
                const BrandFound = brands.find(e => e.url === previousURL);
                if (BrandFound)
                    setBreadcrumbData(e => ({
                        ...e, bread_url: BrandFound.brand,
                        full_url: `/marca/${BrandFound.url}`
                    }));
            }
        }
        
    }, [previousURL, categories, brands]);

    // lista de productos actualizada / cambió url de producto
    useEffect(() => {
        if (!shop_products) { // carga inicial de productos finalizada
            if (products.length <= 0) {
                noProductFound();
                return;
            }
            const ProductModel = products.find(
                e => e.url === _product && e.prod_variants.find(u => u.barcode === _barcode)
            );
            if (!ProductModel) {
                noProductFound();
                return;
            }
            const {
                _id: prod_id, title, url, brand,
                prod_variants, review_summary
            } = ProductModel;

            // elegir variante a mostrar
            const found = prod_variants.find(e => e.barcode === _barcode);
            const VariantModel = found || prod_variants[0];
            
            const {
                _id: prod_var_id, variant_title, price_no_iva,
                price, iva, barcode, images, item_promotion
            } = VariantModel;

            if (barcode !== _barcode) {
                navigate(`/tienda/producto/${_product}/${barcode}`, { replace: true });
                return;
            }
            // producto seleccionado
            setProduct(ProductModel);
            // variante a mostrar
            setVariant({ ...VariantModel, checked: true });
            
            setFullTitle(getTitle(title, variant_title));

            onProductViewed({
                prod_id, prod_var_id, title, variant_title, url,
                brand, review_summary, price_no_iva, price, iva, barcode,
                img: formatMainImage(images), item_promotion
            });

            if (images.length > 0)
                setCurrentImages(images.map(e =>
                    ({
                        original: `${GOOGLE_DRIVE_CDN}${e.id}`,
                        thumbnail: `${GOOGLE_DRIVE_CDN}${e.id}`
                    })
                ));
            else
                setCurrentImages([{
                    original: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`,
                    thumbnail: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`
                }]);
            
            // crear nuevo arreglo e incluir propiedad 'checked'
            if (ProductModel.fbt_item.length > 0)
                setFBTItems(ProductModel.fbt_item);
        }
    }, [_product, _barcode, products, shop_products]);

    // nuevo producto visualizado, actualizar lista de vistos recientemente
    const onProductViewed = (model) => {
        dispatch(shopProductViewed(account_id, model));
    };

    // url no coincide con ningún producto
    const noProductFound = () => {
        if (previousURL)
            navigate(`tienda/categoria/${previousURL}`);
        else
            navigate(`tienda`);
    };

    // cantidad de producto a agregar
    const handleChangeQty = ({ target }) => {
        const value = target.value;
        const _num = Number(target.value);
        if (value.trim() === '' ||
            (regex_num.test(value) && _num > 0))
            setQty(value);
    };

    // agregar al carrito
    const handleSubmit = (event) => {
        event.preventDefault();
        const _qty = Number(qty);
        if (_qty > 0) {
            if (stock <= 0)
                basicMsg('No hay stock disponible');
            else {
                const model = {
                    prod_id, prod_var_id, quantity: _qty
                };
                dispatch(saveItemToCart(model, { flag: true, message: [] }, () => {}));
                // Tag Manager
                window.dataLayer.push({
                    event: 'add-to-cart'
                });
            }
        }
    };

    const ref = useRef(null);

    // const per = (price / 100) * 10;
    // const [time, setTime] = useState(3)
    // const handleChangeTime = (e) => {
    //     setTime(e.target.value)
    // }

    // const [tab, setTab] = useState("1");

    // const handleChangeTab = (event, newValue) => {
    //     setTab(newValue);
    // };

    //modal validar codigo postal
    const [cpModal, setCpModal] = useState(false);

    return (
        prod_id !== '' ? (
            <>
                <Container maxWidth='xxl' sx={{ mt: matches ? 5 : 18 }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit"
                            to="/tienda">Tienda
                        </Link>
                        {
                            bread_url !== '' &&
                                <Link underline="hover" color="inherit"
                                    to={`/tienda${full_url}`}>
                                    { bread_url }
                                </Link>
                        }
                        <Typography color="text.primary">{ fullTitle }</Typography>
                    </Breadcrumbs>
                </Container>

                {/* Producto */}
                <ProductContainer
                    ref={ ref }
                    _product={ _product }
                    account_id={ account_id }
                    product={ product }
                    variant={ variant }
                    setVariant={ setVariant }
                    qty={ qty }
                    setQty={ setQty }
                    fullTitle={ fullTitle }
                    setFullTitle={ setFullTitle }
                    currentImages={ currentImages }
                    setCurrentImages={ setCurrentImages }
                />
                {/*Fin producto */}

                {/* Información adicional del producto */}
                {
                    info !== '' || images.length > 0
                        ?
                        <Container maxWidth='xxl' sx={{ mt: 6 }}>
                            <Typography sx={{ fontWeight: '900', textTransform: 'none', fontSize: '28px' }} paragraph>
                                Información adicional
                            </Typography>
                            {
                                info !== ''
                                    ?
                                    <Box sx={{ mb: 3 }}>
                                        <Typography variant='body1'>{info}</Typography>
                                    </Box>
                                    :
                                    null
                            }
                            {
                                images.length > 0 &&
                                <Grid container spacing={4}>
                                    {
                                        images.map((e) => (
                                            <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} key={e}>
                                                <img src={`${GOOGLE_DRIVE_CDN}${e}`} width='100%' alt='imagen-producto' />
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            }
                        </Container>
                        :
                        null
                }

                <Container maxWidth="xxl" sx={{ mt: 6 }}>
                    {/* Producto en compras frecuentes */}
                    <ProductsFBT
                        fbtItems={fbtItems}
                        setFBTItems={setFBTItems}
                        product={product}
                        variant={variant}
                        setVariant={setVariant} />
                    {/* Fin Producto en compras frecuentes */}
                </Container>

                {/* Vistos recientemente */}
                <RecentlyViewed product_id={prod_id} />

                {/* Reseñas */}
                <Container maxWidth='xl' className="last-view" sx={{ mt: 6 }} ref={ref}>
                    <ProductReviewsSection
                        accountId={account_id}
                        productId={prod_id}
                        variant={variant}
                        signupReturnPath={`tienda/producto/${_product}/${_barcode}`}
                        onSummaryChange={summary => {
                            setProduct(current => ({
                                ...current,
                                review_summary: summary
                            }));
                            dispatch(reviewSummaryUpdated(prod_id, summary));
                        }}
                    />
                </Container>
                {/* Fin Reseñas */}

                <AddToCartDialog
                    variant={ { ...variant, brand } }
                />

                <PostalCodeModal cpModal={cpModal} setCpModal={setCpModal} stock={stock} qty={qty} handleChangeQty={handleChangeQty} handleSubmit={handleSubmit} />
            </>
        )
            :
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}>
                <CircularProgress />
            </Backdrop>
    );
};

export default ProductSample;
